import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './NewRequestSequential.css';
import Aux from '../../../hoc/Auxiliary/Auxiliary';
import Backdrop from '../Backdrop/Backdrop';
import requestImg from '../../../assets/images/request-icon.png';
import closeImg from '../../../assets/images/close-icon.png';
import saveImg from '../../../assets/images/save-icon.png';
import skipImg from '../../../assets/images/skip-white-icon.png';
import syncImg from '../../../assets/images/sync-white-icon.png';
import Icon from '../Icon/Icon';
import ButtonIcon from '../ButtonIcon/ButtonIcon';
import Input from '../Input/Input';
import ProgressBar from './ProgressBar/ProgressBar';
import logError from '../../../store/LogError';
import axios from '../../../axios-trips';
import * as actionTypes from '../../../store/actions';

class NewRequestSequential extends Component {

  createInputConfig = (elementType,
    elementConfig,
    label,
    value = '',
    validation = {},
    valid = true,
    extraClass = null,
    extraAction = null) => {
    return ({
      elementType: elementType,
      elementConfig: elementConfig,
      label: label,
      value: value,
      validation: validation,
      valid: valid,
      extraClass: extraClass,
      extraAction: extraAction,
      touched: false,
      errorMessage: null
    });
  }

  getTodayDate() {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate());
    let date = tomorrow.getFullYear() + "-";
    if ((tomorrow.getMonth() + 1) < 10) {
      date += "0";
    }
    date += (tomorrow.getMonth() + 1) + "-";
    if (tomorrow.getDate() < 10) {
      date += "0"
    }
    date += tomorrow.getDate();
    return date;
  }

  createManagers() {
    if (this.props.managers.length > 2) {
      return;
    }

    axios({
      method: 'get',
      url: '/api/v1/managers',
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        const cardForm = { ...this.state.requestForm };
        this.props.onSetManagers(response.data);
      })
      .catch(error => {
        console.log(error.response);
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/managers'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        } else if (!error.response) {
          this.props.addNotification("Помилка на сервері.", "Danger");
        }
      });
  }

  createLocations() {
    let formattedLocations = [];
    const locations = Object.values(this.props.locations);
    locations.sort(function (a, b) {
      if (a.originatingLocation && !b.originatingLocation) {
        return -1;
      } else if (!a.originatingLocation && b.originatingLocation) {
        return 1;
      } else if (a.region > b.region) {
        return 1;
      } else if (a.region === b.region) {
        return a.locationName > b.locationName ? 1 : -1;
      } else {
        return -1;
      }
    });
    locations.forEach(function (obj) {
      formattedLocations.push({ value: obj.locationName, displayValue: obj.locationName })
    });
    return formattedLocations;
  }

  state = {
    loading: false,
    formStep: 1,
    messages: ["Оберіть Менеджера", "Оберіть 'Звідки'", "Оберіть 'Куди'", "Який тоннаж?", "Тип Заявки?", "Заповніть додаткові деталі та натисніть 'Створити Заявку'"],
    requestForm: {
      manager: this.createInputConfig(
        'input-search',
        {
          options: []
        },
        'Менеджер: ',
        null,
        { required: true },
        false,
        null,
        (ev) => this.createManagers(ev)),
      origin: this.createInputConfig(
        'input-search',
        {
          options: [
            ...this.createLocations()
          ],
          displayOptions: true
        },
        'Звідки: ',
        '',
        {},
        true),
      destination: this.createInputConfig(
        'input-search',
        {
          options: [
            ...this.createLocations()
          ],
          displayOptions: true
        },
        'Куди: ',
        '',
        {},
        true),
      weight: this.createInputConfig(
        'input',
        { type: 'number', step: "0.01", min: "0.1", placeholder: "0" },
        'Вага (тонн): ',
        0.1,
        { required: true },
        true,
        classes.InlineInput),
      weightAlt: this.createInputConfig(
        'select',
        {
          options: [
            { value: 0.1, displayValue: "0.1" },
            { value: 0.2, displayValue: "0.2" },
            { value: 0.3, displayValue: "0.3" },
            { value: 0.4, displayValue: "0.4" },
            { value: 0.5, displayValue: "0.5" },
            { value: 0.6, displayValue: "0.6" },
            { value: 0.7, displayValue: "0.7" },
            { value: 0.8, displayValue: "0.8" },
            { value: 0.9, displayValue: "0.9" },
            { value: 1.0, displayValue: "1.0" },
            { value: 2.1, displayValue: "2.1" },
            { value: 2.2, displayValue: "2.2" },
            { value: 2.3, displayValue: "2.3" },
            { value: 2.4, displayValue: "2.4" },
            { value: 2.5, displayValue: "2.5" },
            { value: 2.6, displayValue: "2.6" },
            { value: 2.7, displayValue: "2.7" },
            { value: 2.8, displayValue: "2.8" },
            { value: 2.9, displayValue: "2.9" },
            { value: 3.0, displayValue: "3.0" },
            { value: 3.1, displayValue: "3.1" },
            { value: 3.2, displayValue: "3.2" },
            { value: 3.3, displayValue: "3.3" },
            { value: 3.4, displayValue: "3.4" },
            { value: 3.5, displayValue: "3.5" },
            { value: 3.6, displayValue: "3.6" },
            { value: 3.7, displayValue: "3.7" },
            { value: 3.8, displayValue: "3.8" },
            { value: 3.9, displayValue: "3.9" },
            { value: 4.0, displayValue: "4.0" },
            { value: 4.1, displayValue: "4.1" },
            { value: 4.2, displayValue: "4.2" },
            { value: 4.3, displayValue: "4.3" },
            { value: 4.4, displayValue: "4.4" },
            { value: 4.5, displayValue: "4.5" },
            { value: 4.6, displayValue: "4.6" },
            { value: 4.7, displayValue: "4.7" },
            { value: 4.8, displayValue: "4.8" },
            { value: 4.9, displayValue: "4.9" },
            { value: 5.0, displayValue: "5.0" },
            { value: 5.1, displayValue: "5.1" },
            { value: 5.2, displayValue: "5.2" },
            { value: 5.3, displayValue: "5.3" },
            { value: 5.4, displayValue: "5.4" },
            { value: 5.5, displayValue: "5.5" },
            { value: 5.6, displayValue: "5.6" },
            { value: 5.7, displayValue: "5.7" },
            { value: 5.8, displayValue: "5.8" },
            { value: 5.9, displayValue: "5.9" },
            { value: 6.0, displayValue: "6.0" },
            { value: 6.1, displayValue: "6.1" },
            { value: 6.2, displayValue: "6.2" },
            { value: 6.3, displayValue: "6.3" },
            { value: 6.4, displayValue: "6.4" },
            { value: 6.5, displayValue: "6.5" },
            { value: 6.6, displayValue: "6.6" },
            { value: 6.7, displayValue: "6.7" },
            { value: 6.8, displayValue: "6.8" },
            { value: 6.9, displayValue: "6.9" },
            { value: 7.0, displayValue: "7.0" },
            { value: 7.1, displayValue: "7.1" },
            { value: 7.2, displayValue: "7.2" },
            { value: 7.3, displayValue: "7.3" },
            { value: 7.4, displayValue: "7.4" },
            { value: 7.5, displayValue: "7.5" },
            { value: 7.6, displayValue: "7.6" },
            { value: 7.7, displayValue: "7.7" },
            { value: 7.8, displayValue: "7.8" },
            { value: 7.9, displayValue: "7.9" },
            { value: 8.0, displayValue: "8.0" },
            { value: 8.1, displayValue: "8.1" },
            { value: 8.2, displayValue: "8.2" },
            { value: 8.3, displayValue: "8.3" },
            { value: 8.4, displayValue: "8.4" },
            { value: 8.5, displayValue: "8.5" },
            { value: 8.6, displayValue: "8.6" },
            { value: 8.7, displayValue: "8.7" },
            { value: 8.8, displayValue: "8.8" },
            { value: 8.9, displayValue: "8.9" },
            { value: 9.0, displayValue: "9.0" },
            { value: 9.1, displayValue: "9.1" },
            { value: 9.2, displayValue: "9.2" },
            { value: 9.3, displayValue: "9.3" },
            { value: 9.4, displayValue: "9.4" },
            { value: 9.5, displayValue: "9.5" },
            { value: 9.6, displayValue: "9.6" },
            { value: 9.7, displayValue: "9.7" },
            { value: 9.8, displayValue: "9.8" },
            { value: 9.9, displayValue: "9.9" },
            { value: 10.0, displayValue: "10.0" },
            { value: 11.0, displayValue: "11.0" },
            { value: 12.0, displayValue: "12.0" },
            { value: 13.0, displayValue: "13.0" },
            { value: 14.0, displayValue: "14.0" },
            { value: 15.0, displayValue: "15.0" },
            { value: 16.0, displayValue: "16.0" },
            { value: 17.0, displayValue: "17.0" },
            { value: 18.0, displayValue: "18.0" },
            { value: 19.0, displayValue: "19.0" },
            { value: 20.0, displayValue: "20.0" }
          ]
        },
        '---',
        0.1,
        { required: true },
        true,
        classes.InlineInput),
      requestType: this.createInputConfig(
        'input-search',
        {
          options: [
            { value: 'ЗК', displayValue: 'ЗК' },
            { value: 'ЗПМ', displayValue: 'ЗПМ' },
            { value: 'ЗПМ_ЗК', displayValue: 'ЗПМ_ЗК' }
          ],
          displayOptions: true
        },
        'Тип Заявки: ',
        '',
        { required: true },
        true,
        classes.InlineInput),
      partialLoad: this.createInputConfig(
        'toggle-switch',
        {},
        'Часткове Завантаження: ',
        false,
        { required: false },
        true,
        classes.InlineInput),
      requestTripDate: this.createInputConfig(
        'input',
        { type: 'date', },
        'Дата: ',
        this.getTodayDate(),
        { required: true, type: 'date' },
        true,
        classes.InlineInput),
      dateFlexibility: this.createInputConfig(
        'select',
        {
          options: [
            { value: '0', displayValue: '0' },
            { value: '1', displayValue: '+1' },
            { value: '2', displayValue: '+2' },
            { value: '3', displayValue: '+3' },
            { value: '4', displayValue: '+4' },
            { value: '5', displayValue: '+5' },
            { value: '6', displayValue: '+6' },
            { value: '7', displayValue: '+7' },
          ],
          animate: 0
        },
        'Гнучкість Дати: ',
        '0',
        { required: true },
        true,
        classes.InlineInput),
      unloading: this.createInputConfig(
        'input',
        { type: 'text' },
        'Адреса / Клієнт: ',
        '',
        { required: false },
        true)
    },
    formIsValid: false
  }

  escFunction = (event) => {
    if (event.keyCode === 27) {
      this.props.closeCard();
    }
  }

  componentDidMount() {
    const query = new URLSearchParams(window.location.search);
    if (query.get("token")) {
      let token = query.get("token");
      axios.get('/api/v1/authorize?token=' + token)
        .then(response => {
          console.log(response);
          if ((response.data === null || response.data === undefined) && localStorage.getItem("access_token") === null) {
            this.props.addNotification("Посилання минуло. Будь ласка, спробуйте ще раз.")
          } else {
            localStorage.setItem("access_token", response.data.access_token);
            localStorage.setItem("refresh_token", response.data.refresh_token);
            localStorage.setItem("name", localStorage.getItem("name"));
            this.props.onAuthenticated(response.data.access_token, response.data.refresh_token, null);
          }
          this.setState({ loading: false });
        })
        .catch(error => {
          console.log(error);
          this.setState({ loading: false });
          if (error.response) {
            logError(
              this.props.access_token,
              this.props.codeToMessage[error.response.status],
              '/api/v1/authorize?token=' + token
            );
            this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
          }
        });
    }
  }

  getManagers() {
    return this.props.managers.map((manager, index) => {
      return (
        { value: manager.name, displayValue: manager.name }
      )
    });
  }

  compareWeights(a, b) {
    if (a.value > b.value) {
      return 1;
    } else if (a.value < b.value) {
      return -1;
    }
    return 0;
  }


  componentDidUpdate(prevProps, prevState) {
    if (prevProps.locations !== this.props.locations) {
      const updatedRequestForm = { ...this.state.requestForm };
      updatedRequestForm.origin.elementConfig.options = [...this.createLocations()];
      updatedRequestForm.destination.elementConfig.options = [...this.createLocations()];
      this.setState({ requestForm: updatedRequestForm });
    }

    if (prevProps.managers !== this.props.managers) {
      const updatedRequestForm = { ...this.state.requestForm };
      updatedRequestForm.manager.elementConfig.options = this.getManagers();
      this.setState({ requestForm: updatedRequestForm });
    }

    if (prevState.requestForm.weight.value !== this.state.requestForm.weight.value && this.state.requestForm.weight.value !== this.state.requestForm.weightAlt.value) {
      const updateForm = { ...this.state.requestForm };
      let foundValue = false;
      for (let i = 0; i < updateForm.weightAlt.elementConfig.options.length; i++) {
        if (updateForm.weightAlt.elementConfig.options[i].value === this.state.requestForm.weight.value) {
          foundValue = true;
          break;
        }
      }
      if (!foundValue) {
        updateForm.weightAlt.elementConfig.options = [...updateForm.weightAlt.elementConfig.options, { value: this.state.requestForm.weight.value, displayValue: this.state.requestForm.weight.value }].sort(this.compareWeights);
      }
      updateForm.weightAlt.value = this.state.requestForm.weight.value;
      this.setState({ requestForm: updateForm });
    }
    if (prevState.requestForm.weightAlt.value !== this.state.requestForm.weightAlt.value && this.state.requestForm.weight.value !== this.state.requestForm.weightAlt.value) {
      const updateForm = { ...this.state.requestForm };
      updateForm.weight.value = this.state.requestForm.weightAlt.value;
      this.setState({ requestForm: updateForm });
    }

    if ((prevProps.origin !== this.props.origin ||
      prevProps.destination !== this.props.destination)) {
      if (this.props.origin === undefined || this.props.destination === undefined) {
        const updatedRequestForm = { ...this.state.requestForm };
        updatedRequestForm.origin.value = "Балахна";
        updatedRequestForm.destination.value = "Баловка";
        this.setState({ requestForm: updatedRequestForm });
      } else {
        const updatedRequestForm = { ...this.state.requestForm };
        updatedRequestForm.origin.value = this.props.origin;
        updatedRequestForm.destination.value = this.props.destination;
        this.setState({ requestForm: updatedRequestForm });
      }
    }

    if (this.props.managerName !== prevProps.managerName) {
      const updatedRequestForm = { ...this.state.requestForm };
      if (updatedRequestForm.manager.elementConfig.options.length <= 2) {
        updatedRequestForm.manager.elementConfig.options = [
          { value: "-", displayValue: "-" },
          { value: this.props.managerName, displayValue: this.props.managerName }
        ];
      }
      updatedRequestForm.manager.value = this.props.managerName;
      updatedRequestForm.manager.valid = this.props.managerName !== null;
      this.setState({ requestForm: updatedRequestForm, formIsValid: this.props.managerName !== null });
    }
  }

  checkValidity(value, rules) {
    let isValid = true;

    if (rules.required) {
      isValid = (value ? (value.trim !== '') : false) && isValid;
    }

    if (rules.type === 'email') {
      let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      isValid = re.test(value) && isValid;
    }

    if (rules.type === "confirmPassword") {
      isValid = this.state.registerForm.password.value === value && isValid;
    }

    if (rules.minLength) {
      isValid = value.length >= rules.minLength && isValid;
    }

    if (rules.maxLength) {
      isValid = value.length <= rules.maxLength && isValid;
    }

    return isValid;
  }

  getErrorMessage(value, rules) {
    let errorMessage = '';

    if (rules.required && (value ? (value.trim === '') : true)) {
      errorMessage = 'Це поле обов\'язкове';
    }

    if (rules.type == 'email') {
      let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(value)) {
        errorMessage = 'Введіть пошту';
      }
    }

    if (rules.type === "confirmPassword" && this.state.registerForm.password.value !== value) {
      errorMessage = 'Паролі повинні співпадати';
    }

    if (rules.minLength && value.length < rules.minLength) {
      errorMessage = 'Мінімальна довжина: ' + rules.minLength;
    }

    if (rules.maxLength && value.length > rules.maxLength) {
      errorMessage = 'Максимальна довжина: ' + rules.minLength;
    }

    return errorMessage;
  }

  formStepHandler = (ev, value) => {
    ev.preventDefault();
    this.setState({ formStep: this.state.formStep + value });
  }

  inputChangedHandler = (event, elementId) => {
    const updatedOrderForm = {
      ...this.state.requestForm
    }
    const updatedFormElement = {
      ...updatedOrderForm[elementId]
    }

    if ((event.target.value === '' || event.target.value === null) &&
      updatedOrderForm[elementId].elementConfig.type === 'number') {
      event.target.value = 0;
    }
    updatedFormElement.value = event.target.value;
    if (!updatedFormElement.touched) {
      if (elementId === "weight" || elementId === "weightAlt") {
        this.setState({ formStep: this.state.formStep + 2 });
      } else {
        this.setState({ formStep: this.state.formStep + 1 });
      }
    }
    updatedFormElement.touched = true;
    updatedFormElement.valid = this.checkValidity(updatedFormElement.value,
      updatedFormElement.validation);
    updatedFormElement.errorMessage = this.getErrorMessage(updatedFormElement.value,
      updatedFormElement.validation);
    updatedOrderForm[elementId] = updatedFormElement;
    let capacityFilled = null;

    let formIsValid = true;
    for (let inputIdentifier in updatedOrderForm) {
      formIsValid = updatedOrderForm[inputIdentifier].valid && formIsValid;
    }

    this.setState({ requestForm: updatedOrderForm, formIsValid: formIsValid });
  }

  newRequestHandler = (event) => {
    event.preventDefault();
    let date = Date.parse(this.state.requestForm.requestTripDate.value);
    date = new Date(date);
    let dateStr = date.getFullYear() + "-";
    if ((date.getMonth() + 1) < 10) {
      dateStr += "0";
    }
    dateStr += (date.getMonth() + 1) + "-";
    if (date.getDate() < 10) {
      dateStr += "0";
    }
    dateStr += date.getDate();

    if (this.props.locations[this.state.requestForm.destination.value].region === 7) {
      this.props.addNotification("Помилка, не можна створити заявку з 'Куди' в Імпорт.", "Danger");
      return;
    }

    const data = {
      tripDate: dateStr,
      origin: {
        ...this.props.locations[this.state.requestForm.origin.value],
      },
      destination: {
        ...this.props.locations[this.state.requestForm.destination.value]
      },
      manager: this.state.requestForm.manager.value,
      priority: "П3",
      weight: this.state.requestForm.weight.value,
      requestTripDate: dateStr,
      dateFlexibility: this.state.requestForm.dateFlexibility.value,
      requestType: this.state.requestForm.requestType.value && this.state.requestForm.requestType.value !== '' ? this.state.requestForm.requestType.value : "ЗК",
      partialLoad: this.state.requestForm.partialLoad.value,
      unloading: this.state.requestForm.unloading.value,
      initiator: false,
      sorting: 0
    }

    axios({
      method: 'post',
      url: '/api/v1/requests?notify=true',
      data: data,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.props.access_token
      },
    })
      .then(response => {
        console.log(response);
        this.props.addNotification("Заявка була успішно створена.", "Success");
        this.onRequestCreatedHandler(response.data);
        this.clearForm();
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: false });
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/requests?notify=true'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
  }

  onRequestCreatedHandler(request) {
    const updatedRequests = [...this.props.requests];
    updatedRequests.push(request);
    this.props.onSetRequests(updatedRequests);
  }

  clearForm() {
    const updatedForm = { ...this.state.requestForm };
    updatedForm.manager.value = null;
    updatedForm.manager.touched = false;
    updatedForm.manager.valid = false;
    updatedForm.origin.value = '';
    updatedForm.origin.touched = false;
    updatedForm.origin.valid = false;
    updatedForm.destination.value = '';
    updatedForm.destination.touched = false;
    updatedForm.destination.valid = false;
    updatedForm.weight.value = 0.1;
    updatedForm.weight.touched = false;
    updatedForm.requestType.value = 'ЗК';
    updatedForm.requestType.touched = false;
    updatedForm.requestType.valid = false;
    updatedForm.partialLoad.value = false;
    updatedForm.unloading.value = '';
    this.setState({ requestForm: updatedForm, formStep: 0 });
  }

  render() {
    let card = null;

    const requestFormArray = [];
    for (let key in this.state.requestForm) {
      requestFormArray.push({ id: key, config: this.state.requestForm[key] });
    }

    card = (
      <Aux>
        <div className={classes.Header}>
          <Icon iconClass={classes.CarIcon} iconSource={requestImg} iconAlt='' className={classes.CardIcon} />
          <p>Нова Заявка</p>
        </div>

        <ProgressBar numPoints={5} progress={this.state.formStep} message={this.state.messages[this.state.formStep]} />

        <form className={classes.NewRequestForm} onSubmit={this.newRequestHandler}>
          <div className={classes.Body} >
            {requestFormArray.map((formElement, index) => {
              if ((index <= this.state.formStep && index >= 0) || (this.state.formStep >= 5 && index >= 5) || (this.state.formStep === 3 && index === 4)) {
                return (
                  <Input
                    key={formElement.id}
                    label={formElement.config.label}
                    elementType={formElement.config.elementType}
                    elementConfig={formElement.config.elementConfig}
                    value={formElement.config.value}
                    extraClass={formElement.config.extraClass}
                    extraAction={formElement.config.extraAction}
                    changed={(event) => this.inputChangedHandler(event, formElement.id)} />
                );
              } else {
                return null;
              }
            })}
          </div>

          <div className={classes.Footer}>
            {this.state.formStep < 5 ?
              <Aux>
                <ButtonIcon
                  btnType='Success'
                  clicked={(ev) => this.formStepHandler(ev, 1)}
                  iconClass={classes.ButtonIcon}
                  iconSource={skipImg}
                  disabled={!this.state.formIsValid}
                  iconAlt=''>ДАЛІ</ButtonIcon>
              </Aux>
              :
              <ButtonIcon
                btnType='Success'
                iconClass={classes.ButtonIcon}
                iconSource={saveImg}
                disabled={!this.state.formIsValid}
                iconAlt=''>СТВОРИТИ ЗАЯВКУ</ButtonIcon>
            }
            <ButtonIcon
              btnType='Neutral'
              clicked={(ev) => this.clearForm()}
              iconClass={classes.ButtonIcon}
              iconSource={syncImg}
              disabled={!this.state.formIsValid}
              iconAlt=''>СКИНУТИ</ButtonIcon>
          </div>
        </form>
      </Aux>
    );

    return (
      <Aux>
        <div className={classes.NewRequestHolder}>
          <div
            className={classes.CardModal}
            style={{
              transform: this.props.show ? 'translateY(0)' : 'translateY(-100vh)',
              opacity: this.props.show ? '1' : '0'
            }}>
            {card}
          </div>
        </div>
      </Aux>
    );
  }
};

const mapStateToProps = state => {
  return {
    access_token: state.access_token,
    notifications: state.notifications,
    carriers: state.carriers,
    routes: state.routes,
    requests: state.requests,
    origin: state.origin,
    destination: state.destination,
    locations: state.locations,
    managers: state.managers,
    managerName: state.managerName,
    codeToMessage: state.codeToMessage
  };
}

const mapDispatchToProps = dispatch => {
  return {
    addNotification: (notification, notificationType) => dispatch({
      type: actionTypes.ADD_NOTIFICATION,
      notification: notification,
      notificationType: notificationType
    }),
    onSetRequests: (requests) => dispatch({
      type: actionTypes.REQUESTS,
      requests: requests
    }),
    onAuthenticated: (tokenValue, refreshValue, name) => dispatch({
      type: actionTypes.LOGIN,
      access_token: tokenValue,
      refresh_token: refreshValue,
      name: name
    }),
    onSetManagers: (managers) => dispatch({
      type: actionTypes.SET_MANAGERS,
      managers: managers
    })
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewRequestSequential);



// WEBPACK FOOTER //
// ./src/components/UI/NewRequestSequential/NewRequestSequential.js